// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/spotcp.css
// module id = 95
// module chunks = 0